import { Outlet, useLocation } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

import { useUploadOpen } from "@/lib/upload-route";

import { AuthGate } from "./auth-gate";
import { AppHeader } from "./header";

const UploadDialog = lazy(() =>
  import("@/features/upload/upload-dialog").then((m) => ({ default: m.UploadDialog })),
);

/**
 * Skip link, header, the routed screen behind the auth gate, and the upload dialog host (also
 * behind the gate, so a deep link to `/upload` never fires requests while signed out).
 */
export function AppLayout() {
  const uploadOpen = useUploadOpen();
  const pathname = useLocation({ select: (location) => location.pathname });
  const reviewing = /^\/guides\/[^/]+\/review\/?$/.test(pathname);
  return (
    <>
      <a href="#main" className="skip-link">
        Skip to content
      </a>
      {!reviewing && <AppHeader />}
      {/* The header is a top bar on phones and the fixed left sidebar at `lg`, so only the
          narrow layout loses 4rem of the viewport to it. */}
      <div className={reviewing ? "min-h-dvh" : "min-h-[calc(100dvh-4rem)] lg:min-h-dvh lg:pl-64"}>
        <AuthGate>
          <main id="main" tabIndex={-1} className="min-w-0 outline-none">
            <Outlet />
          </main>
          {uploadOpen ? (
            <Suspense fallback={null}>
              <UploadDialog />
            </Suspense>
          ) : null}
        </AuthGate>
      </div>
    </>
  );
}
